export const averageExpense = (type: "living" | "annual", family: "single" | "couple" | "child", filter: expenseTypes[]) => {
  const table = averageExpenseTable[family][type];
  const expense = table.map(([genreId, amount]) => {
    const genre = allGenres[String(genreId)];
    return {
      categoryId: genre.category_id,
      genreId,
      categoryName: allCategories[String(genre.category_id)],
      genreName: genre.name,
      amount,
      expenseType: expenseMap[String(genreId)]?.expenseType
    }
  }).filter(e => filter.includes(e.expenseType));
  return {
    value: Math.round(expense.reduce((sum, e) => sum + e.amount, 0) / 1000) * 1000,
    isAverage: true,
    fromExpense: expense,
    filter
  };
}

export type expenseTypes = "living"|"child"|"women"|"car"|"annual"|"exclude";
export const expenseMap: {[key: string]: {name: string, name_en: string, expenseType: expenseTypes }} = 
{"10101":{"name_en":"Groceries","name":"食料品","expenseType":"living"},"10102":{"name_en":"Cafe","name":"カフェ","expenseType":"living"},"10103":{"name_en":"Breakfast","name":"朝ご飯","expenseType":"living"},"10104":{"name_en":"Lunch","name":"昼ご飯","expenseType":"living"},"10105":{"name_en":"Dinner","name":"夜ご飯","expenseType":"living"},"10199":{"name_en":"Other","name":"その他","expenseType":"living"},"10201":{"name_en":"Consumable","name":"消耗品","expenseType":"living"},"10202":{"name_en":"Child-related","name":"子ども関連","expenseType":"child"},"10203":{"name_en":"Pet-related","name":"ペット関連","expenseType":"exclude"},"10204":{"name_en":"Tobacco","name":"タバコ","expenseType":"exclude"},"10299":{"name_en":"Other","name":"その他","expenseType":"living"},"10301":{"name_en":"Train","name":"電車","expenseType":"living"},"10302":{"name_en":"Taxi","name":"タクシー","expenseType":"living"},"10303":{"name_en":"Bus","name":"バス","expenseType":"living"},"10304":{"name_en":"Airfares","name":"飛行機","expenseType":"exclude"},"10399":{"name_en":"Other","name":"その他","expenseType":"living"},"10401":{"name_en":"Cell phone","name":"携帯電話代","expenseType":"living"},"10402":{"name_en":"Fixed-line phones","name":"固定電話代","expenseType":"living"},"10403":{"name_en":"Internet-related","name":"インターネット関連費","expenseType":"living"},"10404":{"name_en":"TV license","name":"放送サービス代","expenseType":"living"},"10405":{"name_en":"Delivery","name":"宅配便","expenseType":"living"},"10406":{"name_en":"Postcard\t Stamps","name":"切手・はがき","expenseType":"living"},"10499":{"name_en":"Other","name":"その他","expenseType":"living"},"10501":{"name_en":"Water","name":"水道代","expenseType":"living"},"10502":{"name_en":"Electricity","name":"電気代","expenseType":"living"},"10503":{"name_en":"Gas","name":"ガス代","expenseType":"living"},"10599":{"name_en":"Other","name":"その他","expenseType":"living"},"10601":{"name_en":"Rent","name":"家賃","expenseType":"exclude"},"10602":{"name_en":"Mortgage","name":"住宅ローン返済","expenseType":"exclude"},"10603":{"name_en":"Furniture","name":"家具","expenseType":"annual"},"10604":{"name_en":"Home electronics","name":"家電","expenseType":"annual"},"10605":{"name_en":"Reform","name":"リフォーム","expenseType":"exclude"},"10606":{"name_en":"Home insurance","name":"住宅保険","expenseType":"exclude"},"10699":{"name_en":"Other","name":"その他","expenseType":"living"},"10701":{"name_en":"Party","name":"飲み会","expenseType":"living"},"10702":{"name_en":"Gifts","name":"プレゼント","expenseType":"living"},"10703":{"name_en":"Ceremonial events","name":"ご祝儀・香典","expenseType":"living"},"10799":{"name_en":"Other","name":"その他","expenseType":"living"},"10801":{"name_en":"Leisure","name":"レジャー","expenseType":"annual"},"10802":{"name_en":"Events","name":"イベント","expenseType":"annual"},"10803":{"name_en":"Cinema","name":"映画・動画","expenseType":"annual"},"10804":{"name_en":"Music","name":"音楽","expenseType":"annual"},"10805":{"name_en":"Cartoon","name":"漫画","expenseType":"annual"},"10806":{"name_en":"Books","name":"書籍","expenseType":"annual"},"10807":{"name_en":"Games","name":"ゲーム","expenseType":"annual"},"10899":{"name_en":"Other","name":"その他","expenseType":"annual"},"10901":{"name_en":"Adult tuition fees","name":"習い事","expenseType":"living"},"10902":{"name_en":"Newspapers","name":"新聞","expenseType":"living"},"10903":{"name_en":"Reference book","name":"参考書","expenseType":"living"},"10904":{"name_en":"Examination fee","name":"受験料","expenseType":"exclude"},"10905":{"name_en":"Tuition","name":"学費","expenseType":"exclude"},"10906":{"name_en":"Student insurance","name":"学資保険","expenseType":"exclude"},"10907":{"name_en":"Cram school","name":"塾","expenseType":"exclude"},"10999":{"name_en":"Other","name":"その他","expenseType":"living"},"11001":{"name_en":"Hospital","name":"病院代","expenseType":"living"},"11002":{"name_en":"Prescription","name":"薬代","expenseType":"living"},"11003":{"name_en":"Life insurance","name":"生命保険","expenseType":"exclude"},"11004":{"name_en":"Medical insurance","name":"医療保険","expenseType":"exclude"},"11099":{"name_en":"Other","name":"その他","expenseType":"living"},"11101":{"name_en":"Clothes","name":"洋服","expenseType":"living"},"11102":{"name_en":"Accessories","name":"アクセサリー・小物","expenseType":"women"},"11103":{"name_en":"Underwear","name":"下着","expenseType":"living"},"11104":{"name_en":"Gym\t Health","name":"ジム・健康","expenseType":"living"},"11105":{"name_en":"Beauty salon","name":"美容院","expenseType":"living"},"11106":{"name_en":"Cosmetics","name":"コスメ","expenseType":"women"},"11107":{"name_en":"Esthetic clinic","name":"エステ・ネイル","expenseType":"women"},"11108":{"name_en":"Laundry","name":"クリーニング","expenseType":"living"},"11199":{"name_en":"Other","name":"その他","expenseType":"living"},"11201":{"name_en":"Gasoline","name":"ガソリン","expenseType":"car"},"11202":{"name_en":"Parking","name":"駐車場","expenseType":"car"},"11203":{"name_en":"Auto insurance","name":"自動車保険","expenseType":"exclude"},"11204":{"name_en":"Auto tax","name":"自動車税","expenseType":"exclude"},"11205":{"name_en":"Auto loan","name":"自動車ローン","expenseType":"exclude"},"11206":{"name_en":"Accreditation fees","name":"免許教習","expenseType":"exclude"},"11207":{"name_en":"Tolls","name":"高速料金","expenseType":"car"},"11299":{"name_en":"Other","name":"その他","expenseType":"car"},"11301":{"name_en":"Pension","name":"年金","expenseType":"exclude"},"11302":{"name_en":"Income tax","name":"所得税","expenseType":"exclude"},"11303":{"name_en":"Sales tax","name":"消費税","expenseType":"exclude"},"11304":{"name_en":"Residence tax","name":"住民税","expenseType":"exclude"},"11305":{"name_en":"Corporate tax","name":"個人事業税","expenseType":"exclude"},"11399":{"name_en":"Other","name":"その他","expenseType":"exclude"},"11401":{"name_en":"Travel","name":"旅行","expenseType":"annual"},"11402":{"name_en":"Home","name":"住宅","expenseType":"exclude"},"11403":{"name_en":"Automotive","name":"自動車","expenseType":"exclude"},"11404":{"name_en":"Motorbike","name":"バイク","expenseType":"exclude"},"11405":{"name_en":"Wedding","name":"結婚","expenseType":"exclude"},"11406":{"name_en":"Childbirth","name":"出産","expenseType":"exclude"},"11407":{"name_en":"Nursing","name":"介護","expenseType":"exclude"},"11408":{"name_en":"Furniture","name":"家具","expenseType":"annual"},"11409":{"name_en":"Home electronics","name":"家電","expenseType":"annual"},"11499":{"name_en":"Other","name":"その他","expenseType":"exclude"},"19901":{"name_en":"Allowance","name":"仕送り","expenseType":"exclude"},"19902":{"name_en":"Pocket money","name":"お小遣い","expenseType":"exclude"},"19903":{"name_en":"Unaccounted","name":"使途不明金","expenseType":"exclude"},"19904":{"name_en":"Advances paid","name":"立替金","expenseType":"exclude"},"19905":{"name_en":"Uncategorized","name":"未分類","expenseType":"exclude"},"19999":{"name_en":"Other","name":"その他","expenseType":"exclude"}}

// ruby -rjson -ne '$l||=[];$l<<$_.chomp.gsub(/,/,"").split(/\s+/).map(&:to_i);END{puts $l.to_json}'
const averageExpenseTable = {
  single: {
    living: [[10101,21829],[10102,1926],[10103,3247],[10104,5926],[10105,8022],[10199,2400],[10201,5487],[10202,2529],[10299,1317],[10301,6063],[10302,1574],[10303,837],[10399,1327],[10401,7055],[10402,4458],[10403,4818],[10404,1868],[10405,293],[10406,177],[10499,942],[10501,1704],[10502,4217],[10503,2830],[10599,1577],[10699,7772],[10701,8213],[10702,4392],[10703,2995],[10799,3116],[10901,5439],[10902,1857],[10903,1036],[10999,2277],[11001,4066],[11002,1369],[11099,2751],[11101,6820],[11102,2618],[11103,871],[11104,3138],[11105,2838],[11106,3374],[11107,5798],[11108,754],[11199,1796],[11201,4040],[11207,1950],[11299,5295]],
    annual: [[10603,22476],[10604,87030],[10801,54785],[10802,29015],[10803,20256],[10804,18583],[10805,20431],[10806,20535],[10807,45812],[11401,81356],[11408,25651],[11409,63371]],
  },
  couple: {
    living: [[10101,35576],[10102,1845],[10103,806],[10104,6011],[10105,6470],[10199,2348],[10201,8443],[10202,8247],[10299,6144],[10301,5647],[10302,1563],[10303,806],[10399,1446],[10401,8597],[10402,4102],[10403,4423],[10404,1853],[10405,687],[10406,255],[10499,895],[10501,2896],[10502,6538],[10503,4467],[10599,1690],[10699,13440],[10701,4517],[10702,4129],[10703,3151],[10799,2764],[10901,4635],[10902,2095],[10903,915],[10999,2520],[11001,9121],[11002,1696],[11099,3138],[11101,7209],[11102,2424],[11103,860],[11104,2876],[11105,3101],[11106,2982],[11107,4153],[11108,808],[11199,1568],[11201,5093],[11207,1958],[11299,6691]],
    annual: [[10603,33200],[10604,95707],[10801,51208],[10802,21972],[10803,15249],[10804,16129],[10805,16929],[10806,17873],[10807,31419],[11401,103632],[11408,40876],[11409,79393]],
  },
  child: {
    living: [[10101,45257],[10102,2386],[10103,767],[10104,6702],[10105,5294],[10199,2321],[10201,9913],[10202,5376],[10299,3054],[10301,5359],[10302,1493],[10303,763],[10399,1556],[10401,9068],[10402,4355],[10403,4412],[10404,1912],[10405,278],[10406,275],[10499,942],[10501,3641],[10502,7765],[10503,5425],[10599,3213],[10699,13753],[10701,14632],[10702,3596],[10703,2955],[10799,2448],[10901,6644],[10902,2185],[10903,1215],[10999,3483],[11001,9658],[11002,1694],[11099,3216],[11101,7788],[11102,2240],[11103,856],[11104,2436],[11105,3031],[11106,2834],[11107,2995],[11108,788],[11199,1507],[11201,5369],[11207,1969],[11299,7042]],
    annual: [[10603,32904],[10604,98079],[10801,48268],[10802,19213],[10803,14026],[10804,11956],[10805,12628],[10806,18755],[10807,21945],[11401,85906],[11408,36168],[11409,79011]],
  },
};

// curl https://api.zaim.net/v2/genre?lang=ja | jq '.genres | map( { (.id|tostring): {name,category_id} } ) | add'
export const allGenres: { [key: string]: {name: string, category_id: number} } = {
  "10101": {
    "name": "食料品",
    "category_id": 101
  },
  "10102": {
    "name": "カフェ",
    "category_id": 101
  },
  "10103": {
    "name": "朝ご飯",
    "category_id": 101
  },
  "10104": {
    "name": "昼ご飯",
    "category_id": 101
  },
  "10105": {
    "name": "晩ご飯",
    "category_id": 101
  },
  "10199": {
    "name": "その他",
    "category_id": 101
  },
  "10201": {
    "name": "消耗品",
    "category_id": 102
  },
  "10202": {
    "name": "子ども関連",
    "category_id": 102
  },
  "10203": {
    "name": "ペット関連",
    "category_id": 102
  },
  "10204": {
    "name": "タバコ",
    "category_id": 102
  },
  "10299": {
    "name": "その他",
    "category_id": 102
  },
  "10301": {
    "name": "電車",
    "category_id": 103
  },
  "10302": {
    "name": "タクシー",
    "category_id": 103
  },
  "10303": {
    "name": "バス",
    "category_id": 103
  },
  "10304": {
    "name": "飛行機",
    "category_id": 103
  },
  "10399": {
    "name": "その他",
    "category_id": 103
  },
  "10401": {
    "name": "携帯電話料金",
    "category_id": 104
  },
  "10402": {
    "name": "固定電話料金",
    "category_id": 104
  },
  "10403": {
    "name": "インターネット関連費",
    "category_id": 104
  },
  "10404": {
    "name": "放送サービス料金",
    "category_id": 104
  },
  "10405": {
    "name": "宅配便",
    "category_id": 104
  },
  "10406": {
    "name": "切手・はがき",
    "category_id": 104
  },
  "10499": {
    "name": "その他",
    "category_id": 104
  },
  "10501": {
    "name": "水道料金",
    "category_id": 105
  },
  "10502": {
    "name": "電気料金",
    "category_id": 105
  },
  "10503": {
    "name": "ガス料金",
    "category_id": 105
  },
  "10599": {
    "name": "その他",
    "category_id": 105
  },
  "10601": {
    "name": "家賃",
    "category_id": 106
  },
  "10602": {
    "name": "住宅ローン返済",
    "category_id": 106
  },
  "10603": {
    "name": "家具",
    "category_id": 106
  },
  "10604": {
    "name": "家電",
    "category_id": 106
  },
  "10605": {
    "name": "リフォーム",
    "category_id": 106
  },
  "10606": {
    "name": "住宅保険",
    "category_id": 106
  },
  "10699": {
    "name": "その他",
    "category_id": 106
  },
  "10701": {
    "name": "飲み会",
    "category_id": 107
  },
  "10702": {
    "name": "プレゼント",
    "category_id": 107
  },
  "10703": {
    "name": "ご祝儀・香典",
    "category_id": 107
  },
  "10799": {
    "name": "その他",
    "category_id": 107
  },
  "10801": {
    "name": "レジャー",
    "category_id": 108
  },
  "10802": {
    "name": "イベント",
    "category_id": 108
  },
  "10803": {
    "name": "映画・動画",
    "category_id": 108
  },
  "10804": {
    "name": "音楽",
    "category_id": 108
  },
  "10805": {
    "name": "漫画",
    "category_id": 108
  },
  "10806": {
    "name": "書籍",
    "category_id": 108
  },
  "10807": {
    "name": "ゲーム",
    "category_id": 108
  },
  "10899": {
    "name": "その他",
    "category_id": 108
  },
  "10901": {
    "name": "習い事",
    "category_id": 109
  },
  "10902": {
    "name": "新聞",
    "category_id": 109
  },
  "10903": {
    "name": "参考書",
    "category_id": 109
  },
  "10904": {
    "name": "受験料",
    "category_id": 109
  },
  "10905": {
    "name": "学費",
    "category_id": 109
  },
  "10906": {
    "name": "学資保険",
    "category_id": 109
  },
  "10907": {
    "name": "塾",
    "category_id": 109
  },
  "10999": {
    "name": "その他",
    "category_id": 109
  },
  "11001": {
    "name": "病院代",
    "category_id": 110
  },
  "11002": {
    "name": "薬代",
    "category_id": 110
  },
  "11003": {
    "name": "生命保険",
    "category_id": 110
  },
  "11004": {
    "name": "医療保険",
    "category_id": 110
  },
  "11099": {
    "name": "その他",
    "category_id": 110
  },
  "11101": {
    "name": "洋服",
    "category_id": 111
  },
  "11102": {
    "name": "アクセサリー・小物",
    "category_id": 111
  },
  "11103": {
    "name": "下着",
    "category_id": 111
  },
  "11104": {
    "name": "ジム・健康",
    "category_id": 111
  },
  "11105": {
    "name": "美容院",
    "category_id": 111
  },
  "11106": {
    "name": "コスメ",
    "category_id": 111
  },
  "11107": {
    "name": "エステ・ネイル",
    "category_id": 111
  },
  "11108": {
    "name": "クリーニング",
    "category_id": 111
  },
  "11199": {
    "name": "その他",
    "category_id": 111
  },
  "11201": {
    "name": "ガソリン",
    "category_id": 112
  },
  "11202": {
    "name": "駐車場",
    "category_id": 112
  },
  "11203": {
    "name": "自動車保険",
    "category_id": 112
  },
  "11204": {
    "name": "自動車税",
    "category_id": 112
  },
  "11205": {
    "name": "自動車ローン",
    "category_id": 112
  },
  "11206": {
    "name": "免許教習",
    "category_id": 112
  },
  "11207": {
    "name": "高速料金",
    "category_id": 112
  },
  "11299": {
    "name": "その他",
    "category_id": 112
  },
  "11301": {
    "name": "年金",
    "category_id": 113
  },
  "11302": {
    "name": "所得税",
    "category_id": 113
  },
  "11303": {
    "name": "消費税",
    "category_id": 113
  },
  "11304": {
    "name": "住民税",
    "category_id": 113
  },
  "11305": {
    "name": "個人事業税",
    "category_id": 113
  },
  "11399": {
    "name": "その他",
    "category_id": 113
  },
  "11401": {
    "name": "旅行",
    "category_id": 114
  },
  "11402": {
    "name": "住宅",
    "category_id": 114
  },
  "11403": {
    "name": "自動車",
    "category_id": 114
  },
  "11404": {
    "name": "バイク",
    "category_id": 114
  },
  "11405": {
    "name": "結婚",
    "category_id": 114
  },
  "11406": {
    "name": "出産",
    "category_id": 114
  },
  "11407": {
    "name": "介護",
    "category_id": 114
  },
  "11408": {
    "name": "家具",
    "category_id": 114
  },
  "11409": {
    "name": "家電",
    "category_id": 114
  },
  "11499": {
    "name": "その他",
    "category_id": 114
  },
  "19901": {
    "name": "仕送り",
    "category_id": 199
  },
  "19902": {
    "name": "お小遣い",
    "category_id": 199
  },
  "19903": {
    "name": "使途不明金",
    "category_id": 199
  },
  "19904": {
    "name": "立替金",
    "category_id": 199
  },
  "19905": {
    "name": "未分類",
    "category_id": 199
  },
  "19906": {
    "name": "現金の引出",
    "category_id": 199
  },
  "19907": {
    "name": "カードの引落",
    "category_id": 199
  },
  "19908": {
    "name": "電子マネーにチャージ",
    "category_id": 199
  },
  "19999": {
    "name": "その他",
    "category_id": 199
  }
};

// curl https://api.zaim.net/v2/category?lang=ja | jq '.categories | map( { (.id|tostring): .["name"] } ) | add'

export const allCategories: { [key: string]: string } = {
  "11": "給与所得",
  "12": "立替金返済",
  "13": "賞与",
  "14": "臨時収入",
  "15": "事業所得",
  "19": "その他",
  "101": "食費",
  "102": "日用雑貨",
  "103": "交通",
  "104": "通信",
  "105": "水道・光熱",
  "106": "住まい",
  "107": "交際費",
  "108": "エンタメ",
  "109": "教育・教養",
  "110": "医療・保険",
  "111": "美容・衣服",
  "112": "クルマ",
  "113": "税金",
  "114": "大型出費",
  "199": "その他"
};

